export default "__VITE_ASSET__Dzt4uOi___"